import http from '@/services/api';

const RESOURCE_NAME = 'api/statistics';

export default {
  subscribeForCounters(data = null) {
    return http.post(`${RESOURCE_NAME}/subscribeForCounters`, data);
  }
};
